/**
 * Small intro band between Hero and TrustBar.
 * Holds the home page's secondary H2 for SEO weight.
 */
export default function HomeIntro() {
  return (
    <section
      data-testid="home-intro"
      className="relative bg-[var(--crest-charcoal)] border-b border-white/5 pt-20 pb-14 md:pt-24 md:pb-16"
    >
      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 text-center">
        <div className="reveal flex items-center justify-center gap-3 mb-6">
          <span className="h-px w-12 bg-[var(--crest-amber)]" />
          <span className="font-display uppercase tracking-[0.4em] text-xs font-semibold text-[var(--crest-amber)]">
            Built for BC weather
          </span>
          <span className="h-px w-12 bg-[var(--crest-amber)]" />
        </div>
        <h2
          data-testid="home-intro-heading"
          className="reveal font-display uppercase font-extrabold text-white leading-[0.95] tracking-tight max-w-4xl mx-auto"
          style={{ fontSize: "clamp(1.6rem, 3.6vw, 2.8rem)" }}
        >
          Roof Repair &amp; Installation Across Vancouver
          <br className="hidden md:block" /> and the Fraser Valley.
        </h2>
        <p
          className="reveal font-body text-base md:text-lg text-white/60 mt-6 max-w-2xl mx-auto leading-relaxed"
          style={{ transitionDelay: "120ms" }}
        >
          From the North Shore to Abbotsford, Crestline delivers
          manufacturer-certified roofing that holds up to wet winters and dry
          summers — backed by a 10-year workmanship warranty in writing.
        </p>
      </div>
    </section>
  );
}
